import { render } from "./FileItem.vue?vue&type=template&id=1b18ee07"
import script from "./FileItem.vue?vue&type=script&lang=ts"
export * from "./FileItem.vue?vue&type=script&lang=ts"
script.render = render

export default script